module.exports = __webpack_public_path__ + "img/79f6fe6.png";